<template>
  <div class="incenters" style="margin-left: 0px;">
    <div style="overflow-x: scroll;">
      <Commontable :rowhe="true" width="1000px" colnum=5 :tableData="tableData" :headerData="headerData" height="100%"></Commontable>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../../../components/common-table.vue'
import Commonbtn from '../../../../../../components/common-btn.vue'
import DialogFrom from '../../../../../../components/dialog-from.vue'
import CommonBtngroup from '../../../../../../components/commongroup.vue'
import Commondropdownlist from '../../../../../../components/common-dropdownlist.vue'
import Pagination from '../../../../../../components/pagination.vue'
import {
  StockReportList,
} from '@/api/home'
export default {
  name: "AddTable",
  components: {
    Commontable,
    Commonbtn,
    DialogFrom,
    CommonBtngroup,
    Commondropdownlist,
    Pagination
  },
  props: ["tableData"],
  data: function () {

    return {
      fromdataadd: [],
      dialogVisibleSelectproduct: false,
      showorhide: true,
      headerData: [{
        prop: 'ID',
        label: '序号',
        columnwidth: 120
      },
      {
        prop: 'WHName',
        label: '仓库名称',
        columnwidth: 180
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
        columnwidth: 180
      },
      {
        prop: 'InvClassName',
        label: '商品名称',
        columnwidth: 180
      },
      {
        prop: 'Batch',
        label: '批号',
        columnwidth: 180
      },
      {
        prop: 'ManuDate',
        label: '生产日期',
        columnwidth: 220,
        // rowhe: true
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
        columnwidth: 180
      },
      {
        prop: 'TaxUnitPrice',
        label: '含税单价',
        columnwidth: 220, 
        // rowhe: true
      },
      {
        prop: 'Quantity',
        label: '数量',
        columnwidth: 220,
        // rowhe: true
      },
      ],
      onchage: 0,
      tableflag: true,
      tableflags: false,
      pageSize: 20,
      pageIndex: 1,
      total: null
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {


    clicktab(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflags = false
      }
      if (index == 1) {
        this.tableflag = false
        this.tableflags = true
      }
      if (this.onchage != index) {
        this.onchage = index
      }
    },
    showclick() {
      this.showorhide = true
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    addclick() {
      this.dialogVisibleSelectproduct = true
      this.$emit('addclick')
    },
    delclick() {

    },
    select() {

    },
    reset() {

    },
    cancelSelectproduct() {
      this.dialogVisibleSelectproduct = false
    },
    dialogOKcancelSelectproduct() {
      this.dialogVisibleSelectproduct = false
    },

  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";
  background-color: #fff;
  width: 980px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 2px;

  div {
    margin-right: 15px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
}
.from {
  width: 100%;
  .inputtop {
    width: 980px;
    height: 40px;
    // box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
    border-bottom: 1px solid #f0f0f0;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 70px;
    animation: shows 0.2s linear;
    overflow: hidden;
  }

  .inputtops {
    width: 980px;
    height: 0;
    // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #f0f0f0;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 70px;
    overflow: hidden;
    // animation: hides 0.5s ease-in;
  }
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 40px;
  }
}
@keyframes hides {
  0% {
    opacity: 0;
    height: 40px;
  }
  100% {
    opacity: 1;
    height: 0px;
  }
}
</style>
